module.exports = __webpack_public_path__ + "static/media/ShuffleboardLogo.a67cbde3.png";